import { html } from 'diagram-js/lib/ui'

export default function BlackAndWhiteHTM(props) {
  const { id, getValue, onChange } = props

  const value = Boolean(getValue('blackAndWhite')())

  const handleChange = (event) => {
    const newValue = event.target.checked
    onChange('blackAndWhite')(newValue)
  }

  return html`
    <div data-entry-id="blackAndWhite" class="bio-properties-panel-entry bio-properties-panel-toggle-switch-entry">
      <div class="bio-properties-panel-toggle-switch inline">
        <label for="${id}" class="bio-properties-panel-label">
          <div tabindex="0">Black and white filter</div>
        </label>
        <div class="bio-properties-panel-field-wrapper">
          <label class="bio-properties-panel-toggle-switch__switcher">
            <input
              id="${id}"
              type="checkbox"
              name="blackAndWhite"
              class="bio-properties-panel-input"
              checked=${value}
              onChange=${handleChange}
            />
            <span class="bio-properties-panel-toggle-switch__slider"></span>
          </label>
        </div>
      </div>
    </div>
  `
}
